import React from "react";
import ReactDOM from "react-dom/client";

import "./index.scss";
import "./HamburgerMenu.scss";
import reportWebVitals from "./reportWebVitals";
import { Router2 } from "./Router2";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router2 />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
